<a
  [routerLink]="['/programmes', programme().slug]"
  class="group flex h-full cursor-pointer flex-col overflow-hidden rounded-2xl border border-slate-200/80 bg-white text-inherit no-underline shadow-sm transition duration-200 hover:-translate-y-0.5 hover:shadow-md"
>
  <img [src]="programme().image" alt="" loading="lazy" class="w-full" />

  <div class="flex flex-1 flex-col p-4">
    @if (programme().category) {
      <!-- Category -->
      <span
        class="inline-flex w-fit rounded-full bg-sky-50 px-2 py-0.5 text-[11px] font-medium text-sky-700"
      >
        {{ programme().category }}
      </span>
    }

    <!-- Title -->
    <h3 class="mt-2.5 line-clamp-2 text-lg font-semibold leading-snug text-slate-900">
      {{ programme().title }}
    </h3>

    @if (programme().venue) {
      <!-- Venue -->
      <p class="mt-1.5 flex items-start gap-1 text-[13px] text-slate-500">
        <svg
          class="mt-0.5 h-3.5 w-3.5 shrink-0"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
          />
        </svg>
        <span class="line-clamp-1">{{ programme().venue }}</span>
      </p>
    }
  </div>
</a>
